import { IAdapterConfig } from '@care-portals/api-interfaces';

export const JunctionConfig: IAdapterConfig = {
  junction: {
    label: 'Junction',
    functions: {
      createOrder: {
        version: 2,
        label: 'Create Order in Junction',
        middlewareHandler: 'junction',
        params: [{ label: 'Order ID', key: 'orderId', type: 'string' }]
      },
      handleWebhook: {
        version: 2,
        passPayload: true,
        label: 'Update Order from Webhook',
        middlewareHandler: 'junction',
        pipelines: ['webhook'],
        params: []
      },
      createUser: {
        version: 2,
        passPayload: false,
        label: 'Create User in Junction',
        middlewareHandler: 'junction',
        params: [{ label: 'Customer ID', key: 'customerId', type: 'string' }]
      }
    }
  }
};
